<template>
  <div class="hello">
    <menupicker value="newsletters">{{ active }}</menupicker>
    <h1>{{ msg }}</h1>
    <div class="center green rcorners1">
      <p v-for="p in content " v-html="p"/>
      <img class="photos" v-for="p in photos " :src="'https://s3-us-west-2.amazonaws.com/gmbch-photos/'+p"/>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Vuex from 'vuex';
  import Vuetify from 'vuetify';
  import MenuPicker from './MenuPicker.vue';
  import DynamoDb from 'aws-sdk/clients/dynamodb';
  import AWS from 'aws-sdk';

  Vue.use(Vuetify);
  Vue.use(Vuex);
  Vue.component('menupicker', MenuPicker);

  export default {
    name: 'Newsletters',
    data() {
      return {
        active: 'newsletters',
        msg: 'Newsletters',
        content: '',
        photos: []
      }
    },
    methods: {
      loadS3Images(awscredentials) {
        const s3 = new AWS.S3({
          region: localStorage.getItem('region'),
          credentials: awscredentials,
        });

        var params = {
          Bucket: "gmbch-photos",
          MaxKeys: 10
        };

        return new Promise((resolve, reject) => {
          s3.listObjectsV2(params, function (err, data) {
            if (err) {
              console.error(err, err.stack);
              reject(`s3 error ${error.message}`);
            }
            resolve(data);
          });
        })
      },
      loadData(awscredentials) {
        const docClient = new DynamoDb.DocumentClient({
          region: localStorage.getItem('region'),
          credentials: awscredentials,
        });

        const query = {
          TableName: 'about-webcontents',
          KeyConditions: {
            pageid: {
              ComparisonOperator: 'EQ',
              AttributeValueList: ['newsletter']
            }
          }
        }
        return new Promise((resolve, reject) => {
          docClient.query(
            query,
            (error, data) => {
              if (error) {
                console.error('dynamodb error: ' + error.message);
                reject(`dynamodb error: ${error.message}`);
              }
              resolve(data);
            }
          )
        })
      },
      parseData(data) {
        console.log(JSON.stringify(data.Items[0].content, null, 2));
        let paras = data.Items[0].content.split('\n');
        this.content = paras;
      },
      parseS3Data(data) {
        console.log(JSON.stringify(data, null, 2));
        this.photos = [];
        for (let i = 0; i < data.Contents.length; i++) {
          this.photos[i] = data.Contents[i].Key;
        }
      },
      initCredentials() {
        const credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: localStorage.getItem('poolid'),
        }, {region: localStorage.getItem('region')});
        return credentials;
      }
    },
    mounted() {
      const creds = this.initCredentials();
      this.loadData(creds)
        .then(data => this.parseData(data));
      this.loadS3Images(creds)
        .then(data => this.parseS3Data(data));
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
    font-size: large;
  }

  ul .link {
    list-style-type: none;
    padding: 0;
  }

  li .link {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  p {
    text-align: left;
  }

  .bodycenter {
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    width: 75%;
    text-align: left;
  }

  .center {
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    margin: auto;
    margin-top: 5px;
    width: 95%;
    padding: 10px;
  }

  .green {
    border: 3px solid green;
  }

  .normalli {
    margin-bottom: 1em;
  }

  .rcorners1 {
    border-radius: 25px;
    padding: 5px;
  }

  .subinfo {
    margin: 0;
  }

  .photos {
    height: 300px;
    margin: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Newsletters.vue